import script from "./GuideArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideArticle.vue?vue&type=script&setup=true&lang=js"

import "./GuideArticle.vue?vue&type=style&index=0&id=36c8086d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c8086d"]])

export default __exports__